import { render, staticRenderFns } from "./pushed-list.vue?vue&type=template&id=0bf20760&lang=pug&"
import script from "./pushed-list.vue?vue&type=script&lang=js&"
export * from "./pushed-list.vue?vue&type=script&lang=js&"
import style0 from "./pushed-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports